import { useEffect, useState } from "react";

// Returns a callback ref and the current { width, height } of the attached element
// Usage:
//   const [setRef, { width }] = useElementSize();
//   return <div ref={setRef}>...</div>
export default function useElementSize() {
  const [el, setEl] = useState(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!el) return;

    let rafId = null;
    const update = () => {
      if (!el) return;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const next = {
          width: Math.round(rect.width),
          height: Math.round(rect.height),
        };
        setSize((prev) =>
          prev.width !== next.width || prev.height !== next.height ? next : prev
        );
      });
    };

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(update);
      ro.observe(el);
    } else {
      window.addEventListener("resize", update);
    }

    // Initial measurement
    update();

    return () => {
      if (ro) ro.disconnect();
      else window.removeEventListener("resize", update);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [el]);

  return [setEl, size];
}
